import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { Anchor, Globe, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="mt-24 bg-[#0A2540] text-stone-200" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[var(--brand-primary)] text-white">
              <Anchor className="h-4 w-4" />
            </span>
            <span className="font-display text-2xl">Al Quseir</span>
          </div>
          <p className="text-stone-400 text-sm leading-relaxed max-w-md">{t("footer_about")}</p>
          <div className="mt-6 flex items-center gap-4 text-stone-400 text-sm">
            <span className="inline-flex items-center gap-2"><MapPin className="h-4 w-4" /> Red Sea, Egypt</span>
            <span className="inline-flex items-center gap-2"><Globe className="h-4 w-4" /> alquseir.info</span>
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-stone-400 mb-4">Discover</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/history" className="hover:text-white">{t("nav_history")}</Link></li>
            <li><Link to="/sights" className="hover:text-white">{t("nav_sights")}</Link></li>
            <li><Link to="/beaches" className="hover:text-white">{t("nav_beaches")}</Link></li>
            <li><Link to="/gallery" className="hover:text-white">{t("nav_gallery")}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-stone-400 mb-4">Plan</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/directory" className="hover:text-white">{t("nav_directory")}</Link></li>
            <li><Link to="/tips" className="hover:text-white">{t("nav_tips")}</Link></li>
            <li><Link to="/map" className="hover:text-white">{t("nav_map")}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-stone-400 mb-4">Business</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/advertise" className="hover:text-white">{t("nav_advertise")}</Link></li>
            <li><Link to="/admin/login" className="hover:text-white">{t("nav_admin")}</Link></li>
            <li><a href="mailto:hello@alquseir.info" className="hover:text-white inline-flex items-center gap-1"><Mail className="h-3.5 w-3.5" /> Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-700/60">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-stone-400">
          <p>© {new Date().getFullYear()} Al Quseir Tourism. {t("footer_rights")}</p>
          <p className="font-display tracking-wide">Made on the Red Sea coast.</p>
        </div>
      </div>
    </footer>
  );
}
